<template>
    <div
        class="bg-zinc-50 dark:bg-black font-sans antialiased text-zinc-900 dark:text-zinc-100 transition-colors duration-500">
        <div class="max-w-[1400px] mx-auto p-3 sm:p-6 lg:p-8">
            <div
                class="relative overflow-hidden rounded-2xl sm:rounded-[32px] border border-zinc-200 dark:border-zinc-800 bg-white dark:bg-[#09090b] shadow-2xl shadow-zinc-200/50 dark:shadow-black/80 transition-all duration-500">

                <div
                    class="absolute -top-[100px] -right-[100px] sm:-top-[200px] sm:-right-[200px] w-[300px] h-[300px] sm:w-[500px] sm:h-[500px] bg-blue-500/20 blur-[80px] sm:blur-[120px] rounded-full pointer-events-none mix-blend-screen animate-blob">
                </div>
                <div
                    class="absolute -bottom-[100px] -left-[100px] sm:-bottom-[200px] sm:-left-[200px] w-[300px] h-[300px] sm:w-[500px] sm:h-[500px] bg-purple-500/20 blur-[80px] sm:blur-[120px] rounded-full pointer-events-none mix-blend-screen animate-blob animation-delay-2000">
                </div>
                <div
                    class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[200px] h-[200px] bg-indigo-500/10 blur-[100px] rounded-full pointer-events-none mix-blend-screen animate-blob animation-delay-4000">
                </div>

                <div class="relative z-10 flex flex-col lg:flex-row min-h-[auto] lg:min-h-[700px]">
                    <main class="flex-1 p-5 sm:p-8 lg:p-10 flex flex-col gap-6 sm:gap-8">

                        <div
                            class="flex flex-col sm:flex-row sm:items-start justify-between gap-4 animate-in fade-in slide-in-from-bottom-4 duration-700">
                            <div>
                                <div class="flex items-center gap-2 mb-2">
                                    <span
                                        class="px-2 py-0.5 rounded-full bg-blue-500/10 text-blue-600 dark:text-blue-400 border border-blue-500/20 text-[9px] sm:text-[10px] font-bold uppercase tracking-widest shadow-[0_0_10px_rgba(59,130,246,0.2)]">
                                        Generate with AI
                                    </span>
                                </div>
                                <h1
                                    class="text-2xl sm:text-3xl font-bold tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-zinc-900 via-zinc-700 to-zinc-500 dark:from-white dark:via-zinc-200 dark:to-zinc-500">
                                    NexGrid Palette
                                </h1>
                                <p class="mt-1 text-sm text-zinc-500 dark:text-zinc-400 font-medium leading-relaxed">
                                    Describe your vision, get a UI-ready design system.
                                </p>
                            </div>

                            <div class="flex items-center gap-3 self-end sm:self-auto">

                                <router-link to="/dashboard/hub"
                                    class="group relative flex items-center justify-center h-10 w-10 rounded-2xl border border-zinc-200/80 dark:border-zinc-800 bg-white dark:bg-zinc-900 text-zinc-400 hover:text-sky-500 hover:border-sky-500/30 hover:shadow-lg hover:shadow-sky-500/10 transition-all duration-300 hover:-translate-y-0.5 active:scale-95"
                                    title="Tutorial Hub">
                                    <span
                                        class="material-symbols-rounded text-[20px] group-hover:rotate-12 transition-transform duration-300">school</span>
                                </router-link>

                                <div class="hidden sm:block">
                                    <transition name="fade" mode="out-in">
                                        <button v-if="result" @click="clearState"
                                            class="group flex items-center gap-2 px-4 py-2 rounded-xl bg-zinc-100 dark:bg-zinc-800 text-zinc-600 dark:text-zinc-400 hover:bg-zinc-900 hover:text-zinc-50 dark:hover:bg-white dark:hover:text-black transition-all duration-300 shadow-sm hover:shadow-lg hover:-translate-y-0.5">
                                            <span
                                                class="material-symbols-rounded text-lg group-hover:-rotate-90 transition-transform duration-500">add_circle</span>
                                            <span class="text-xs font-bold uppercase tracking-wider">New Palette</span>
                                        </button>

                                        <div v-else
                                            class="w-10 h-10 rounded-xl bg-gradient-to-br from-zinc-100 to-zinc-50 dark:from-zinc-800 dark:to-zinc-900 border border-zinc-200 dark:border-zinc-700 flex items-center justify-center shadow-inner hover:scale-110 transition-transform duration-300">
                                            <span
                                                class="material-symbols-rounded text-zinc-400 dark:text-zinc-500">grid_on</span>
                                        </div>
                                    </transition>
                                </div>
                            </div>
                        </div>

                        <div class="space-y-4 animate-in fade-in slide-in-from-bottom-6 duration-1000 delay-100">
                            <div class="relative group">
                                <div
                                    class="absolute -inset-0.5 bg-gradient-to-r from-blue-500 to-purple-600 rounded-2xl opacity-0 group-focus-within:opacity-30 transition duration-700 blur-lg">
                                </div>
                                <textarea v-model="descricao"
                                    placeholder="E.g., A minimalist dashboard for a fintech app, dark mode..." rows="3"
                                    class="relative block w-full rounded-xl border-0 bg-zinc-50 dark:bg-zinc-900/60 ring-1 ring-inset ring-zinc-200 dark:ring-zinc-800 focus:ring-2 focus:ring-inset focus:ring-blue-500 px-4 py-3 text-base sm:text-sm leading-relaxed transition-all duration-300 placeholder:text-zinc-400 resize-none shadow-sm focus:shadow-md pb-12 sm:pb-3 hover:bg-white dark:hover:bg-zinc-900/80"></textarea>

                                <div class="absolute bottom-3 right-3 flex items-center gap-2">
                                    <span
                                        class="text-[10px] text-zinc-400 dark:text-zinc-600 hidden sm:block opacity-0 group-focus-within:opacity-100 transition-opacity duration-300">
                                        ⌘ + Enter to generate
                                    </span>
                                    <button type="button" @click="gerar" :disabled="loading || !descricao.trim()"
                                        class="relative overflow-hidden inline-flex items-center gap-2 px-3 py-1.5 sm:px-4 sm:py-1.5 rounded-lg bg-zinc-900 dark:bg-white text-zinc-50 dark:text-black text-xs font-semibold shadow-lg shadow-zinc-500/20 hover:scale-105 active:scale-95 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100 group/btn">
                                        <div
                                            class="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover/btn:animate-shimmer">
                                        </div>
                                        <span v-if="loading"
                                            class="animate-spin material-symbols-rounded text-sm">progress_activity</span>
                                        <span v-else class="material-symbols-rounded text-sm">auto_awesome</span>
                                        {{ loading ? 'Generating...' : 'Generate' }}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="flex-1 min-h-[200px]">
                            <transition name="fade" mode="out-in">
                                <div v-if="loading" key="loader" class="h-full w-full flex flex-col gap-4">
                                    <div class="h-6 w-1/3 bg-zinc-200 dark:bg-zinc-800 rounded-md animate-pulse"></div>
                                    <div
                                        class="h-40 sm:flex-1 rounded-2xl bg-zinc-100 dark:bg-zinc-800/50 animate-pulse">
                                    </div>
                                </div>

                                <div v-else-if="!result" key="empty"
                                    class="h-full min-h-[250px] flex flex-col items-center justify-center text-center p-6 border border-dashed border-zinc-200 dark:border-zinc-800 rounded-2xl bg-zinc-50/30 dark:bg-zinc-900/20 hover:bg-zinc-50/80 dark:hover:bg-zinc-900/40 transition-colors duration-500 group">
                                    <div
                                        class="w-12 h-12 mb-3 rounded-full bg-zinc-100 dark:bg-zinc-800 flex items-center justify-center group-hover:scale-110 group-hover:rotate-12 transition-all duration-500">
                                        <span
                                            class="material-symbols-rounded text-zinc-400 text-xl group-hover:text-blue-500 transition-colors">palette</span>
                                    </div>
                                    <p class="text-sm font-medium text-zinc-900 dark:text-zinc-200">No palette generated
                                        yet</p>
                                    <p class="text-xs text-zinc-500 dark:text-zinc-400 max-w-xs mt-1">Start by typing a
                                        prompt above to create your unique design system.</p>
                                </div>

                                <div v-else key="result" class="space-y-6">
                                    <div
                                        class="flex flex-col sm:flex-row sm:items-center justify-between gap-2 animate-in fade-in slide-in-from-bottom-2 duration-500">
                                        <div>
                                            <h3
                                                class="text-lg font-semibold text-zinc-900 dark:text-zinc-100 tracking-tight">
                                                {{ result.name }}</h3>
                                            <p class="text-xs text-zinc-500 max-w-md line-clamp-1">{{ result.description
                                            }}</p>
                                        </div>
                                        <button @click="copyCurrentPalette"
                                            class="self-start sm:self-auto text-xs flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-zinc-100 dark:bg-zinc-800/80 text-zinc-600 dark:text-zinc-400 hover:text-zinc-900 dark:hover:text-zinc-100 hover:bg-zinc-200 dark:hover:bg-zinc-700 transition-all active:scale-95">
                                            <span class="material-symbols-rounded text-sm">{{ copiedGlobal ? 'check' :
                                                'content_copy' }}</span>
                                            <span v-if="copiedGlobal">Copied!</span>
                                            <span v-else>Copy JSON</span>
                                        </button>
                                    </div>

                                    <div class="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-7 gap-3">
                                        <div v-for="(color, name, index) in result.colors" :key="name"
                                            class="group relative flex flex-col gap-2 cursor-pointer animate-enter"
                                            :style="{ animationDelay: `${index * 100}ms` }" @click="copy(color)">
                                            <div class="aspect-[3/4] sm:aspect-square md:aspect-[3/4] rounded-xl shadow-sm border border-black/5 dark:border-white/5 transition-all duration-500 ease-out group-hover:-translate-y-2 group-hover:shadow-xl group-hover:shadow-black/5 dark:group-hover:shadow-black/50 relative overflow-hidden ring-0 group-hover:ring-2 ring-transparent group-hover:ring-white/20 dark:group-hover:ring-white/10"
                                                :style="{ backgroundColor: color }">
                                                <div
                                                    class="absolute inset-0 bg-gradient-to-b from-white/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                                                </div>
                                                <div
                                                    class="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 scale-75 group-hover:scale-100">
                                                    <div
                                                        class="bg-black/20 backdrop-blur-md rounded-full p-2.5 text-white shadow-lg">
                                                        <span
                                                            class="material-symbols-rounded text-lg">content_copy</span>
                                                    </div>
                                                </div>
                                            </div>

                                            <div
                                                class="text-center transition-all duration-300 group-hover:translate-y-1">
                                                <p
                                                    class="text-[9px] sm:text-[10px] uppercase font-bold text-zinc-400 dark:text-zinc-500 tracking-wider mb-0.5 truncate px-1 group-hover:text-zinc-600 dark:group-hover:text-zinc-300 transition-colors">
                                                    {{ formatKey(name) }}
                                                </p>
                                                <p
                                                    class="text-[10px] sm:text-[11px] font-mono text-zinc-600 dark:text-zinc-300 opacity-80 group-hover:opacity-100">
                                                    {{ color }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div
                                        class="pt-6 border-t border-zinc-100 dark:border-zinc-800 animate-in fade-in slide-in-from-bottom-4 duration-700 delay-500">
                                        <p
                                            class="text-[10px] font-bold uppercase text-zinc-400 tracking-widest mb-3 pl-1">
                                            Export Assets</p>
                                        <div class="grid grid-cols-3 sm:flex sm:flex-wrap gap-2">
                                            <button v-for="fmt in ['CSS', 'SCSS', 'Tailwind', 'SVG', 'PNG']" :key="fmt"
                                                @click="handleExport(fmt)"
                                                class="relative overflow-hidden justify-center px-3 py-2 sm:py-1.5 rounded-lg border border-zinc-200 dark:border-zinc-700 bg-white dark:bg-zinc-800/50 hover:bg-zinc-50 dark:hover:bg-zinc-700 text-[10px] sm:text-[11px] font-medium transition-all duration-300 hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 flex items-center gap-1.5 group/export">
                                                <span
                                                    class="w-1.5 h-1.5 rounded-full bg-zinc-300 dark:bg-zinc-500 group-hover/export:bg-blue-500 transition-colors"></span>
                                                {{ fmt }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </transition>
                        </div>
                    </main>

                    <aside
                        class="w-full lg:w-80 border-t lg:border-t-0 lg:border-l border-zinc-200 dark:border-zinc-800 bg-zinc-50/80 dark:bg-black/40 backdrop-blur-2xl transition-colors duration-500">
                        <div class="p-5 sm:p-6 h-full flex flex-col">
                            <div
                                class="flex items-center justify-between mb-4 lg:mb-6 sticky top-0 bg-transparent z-10">
                                <h2 class="text-xs font-bold uppercase tracking-widest text-zinc-500">History</h2>
                                <button @click="refreshHistory"
                                    class="p-1.5 rounded-full hover:bg-zinc-200 dark:hover:bg-zinc-800 transition-all duration-300 hover:rotate-180 active:scale-90">
                                    <span class="material-symbols-rounded text-base text-zinc-400">refresh</span>
                                </button>
                            </div>

                            <div class="relative">
                                <transition name="fade">
                                    <div v-if="historyLoading"
                                        class="absolute inset-0 flex items-start justify-center pt-10 bg-zinc-50/50 dark:bg-black/50 backdrop-blur-sm z-20 h-[460px]">
                                        <span
                                            class="animate-spin material-symbols-rounded text-zinc-400">progress_activity</span>
                                    </div>
                                </transition>

                                <div class="pr-1 space-y-3 custom-scrollbar overflow-y-auto max-h-[460px]">
                                    <transition-group name="list" tag="div" class="space-y-3">
                                        <template v-if="history.length">
                                            <div v-for="item in history" :key="item.id" @click="applyHistory(item)"
                                                class="group relative p-3 rounded-xl border border-zinc-200 dark:border-zinc-800/60 bg-white dark:bg-zinc-900/40 hover:border-blue-500/30 hover:bg-zinc-50 dark:hover:bg-zinc-800/60 hover:shadow-lg hover:shadow-blue-500/5 transition-all duration-300 cursor-pointer hover:-translate-x-1">
                                                <div
                                                    class="flex h-2 w-full rounded-full overflow-hidden mb-2.5 opacity-80 group-hover:opacity-100 transition-opacity">
                                                    <div v-for="(c, k) in parseColors(item.colorsJson)" :key="k"
                                                        class="flex-1 h-full transform transition-transform duration-500 hover:scale-125 hover:z-10"
                                                        :style="{ backgroundColor: c }"></div>
                                                </div>

                                                <p
                                                    class="text-xs font-medium text-zinc-700 dark:text-zinc-300 line-clamp-2 leading-relaxed mb-1 transition-colors group-hover:text-blue-600 dark:group-hover:text-blue-400">
                                                    {{ item.prompt }}
                                                </p>
                                                <div class="flex items-center justify-between mt-2">
                                                    <span class="text-[10px] text-zinc-400">{{
                                                        formatDate(item.createdAt) }}</span>
                                                    <button @click.stop="openDeleteModal(item)"
                                                        class="opacity-0 lg:group-hover:opacity-100 lg:-translate-x-2 lg:group-hover:translate-x-0 p-1.5 rounded-full hover:bg-red-50 dark:hover:bg-red-900/30 text-zinc-400 hover:text-red-500 transition-all duration-300">
                                                        <span class="material-symbols-rounded text-sm">delete</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </template>
                                    </transition-group>

                                    <div v-if="!historyLoading && !history.length" class="text-center py-10 opacity-60">
                                        <span
                                            class="material-symbols-rounded text-zinc-300 text-3xl mb-2">history</span>
                                        <p class="text-xs text-zinc-400">No recent history</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </aside>
                </div>
            </div>
        </div>

        <transition name="modal">
            <div v-if="showDeleteModal"
                class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm transition-opacity">
                <div
                    class="bg-white dark:bg-zinc-900 rounded-2xl shadow-2xl max-w-sm w-full p-6 border border-zinc-200 dark:border-zinc-800 transform transition-all scale-100">
                    <div
                        class="w-10 h-10 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center mb-4 text-red-500">
                        <span class="material-symbols-rounded">delete_forever</span>
                    </div>
                    <h3 class="text-base font-semibold mb-2 dark:text-zinc-100">Delete from history?</h3>
                    <p class="text-sm text-zinc-500 dark:text-zinc-400 mb-6 leading-relaxed">This action cannot be
                        undone. This
                        palette will be permanently removed.</p>
                    <div class="flex justify-end gap-3">
                        <button @click="closeDeleteModal"
                            class="px-4 py-2 text-xs font-medium rounded-lg hover:bg-zinc-100 dark:hover:bg-zinc-800 dark:text-zinc-300 transition-colors">Cancel</button>
                        <button @click="confirmDelete"
                            class="px-4 py-2 text-xs font-medium rounded-lg bg-red-500 text-white hover:bg-red-600 shadow-lg shadow-red-500/20 active:scale-95 transition-all">Delete</button>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'

const descricao = ref('')
const loading = ref(false)
const result = ref(null)
const history = ref([])
const historyLoading = ref(false)
const showDeleteModal = ref(false)
const itemToDelete = ref(null)
const copiedGlobal = ref(false)

// NEW: Function to clear the state and start fresh
function clearState() {
    result.value = null
    descricao.value = ''
}

async function gerar() {
    if (!descricao.value.trim()) return
    loading.value = true
    result.value = null
    try {
        const { data } = await axios.post('https://backend.nexgridco.com/color-ai/gerar', {
            descricao: descricao.value,
            contexto: 'ui'
        })
        setTimeout(() => {
            result.value = data
            refreshHistory()
        }, 600)
    } catch (e) {
        console.error(e)
    } finally {
        setTimeout(() => loading.value = false, 600)
    }
}

async function fetchHistory() {
    historyLoading.value = true
    try {
        const { data } = await axios.get('/color-ai/history/generator')
        history.value = Array.isArray(data) ? data : []
    } catch {
        history.value = []
    } finally {
        historyLoading.value = false
    }
}

async function refreshHistory() {
    await fetchHistory()
}

const parseColors = (jsonColors) => {
    if (typeof jsonColors === 'object' && jsonColors !== null) {
        return Object.values(jsonColors).slice(0, 5)
    }
    return []
}

function applyHistory(item) {
    loading.value = true
    descricao.value = item.prompt || ''
    result.value = null
    setTimeout(() => {
        result.value = {
            name: item.paletteName || 'History Item',
            description: item.prompt,
            colors: item.colorsJson
        }
        loading.value = false
    }, 400)
}

function copy(text) {
    navigator.clipboard.writeText(text)
}

function copyCurrentPalette() {
    if (!result.value) return
    navigator.clipboard.writeText(JSON.stringify(result.value, null, 2))
    copiedGlobal.value = true
    setTimeout(() => copiedGlobal.value = false, 2000)
}

function formatKey(key) {
    return key.replace(/([A-Z])/g, ' $1').trim()
}

function formatDate(dateStr) {
    if (!dateStr) return ''
    return new Date(dateStr).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
}

function handleExport(type) {
    if (!result.value) return
    const fns = {
        'JSON': exportJSON,
        'CSS': exportCSS,
        'SCSS': exportSCSS,
        'Tailwind': exportTailwind,
        'SVG': exportSVG,
        'PNG': exportPNG
    }
    if (fns[type]) fns[type]()
}

function downloadText(text, filename) {
    const blob = new Blob([text], { type: 'text/plain' })
    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = filename
    a.click()
    URL.revokeObjectURL(url)
}

function exportJSON() {
    downloadText(JSON.stringify(result.value, null, 2), `${result.value.name}.json`)
}

function exportCSS() {
    const c = result.value.colors
    const out = `:root {
  --surface: ${c.surface};
  --surface-alt: ${c.surfaceAlt};
  --accent: ${c.accent};
  --accent-secondary: ${c.accentSecondary};
  --text-primary: ${c.textPrimary};
  --text-secondary: ${c.textSecondary};
  --border: ${c.border};
}`
    downloadText(out, `${result.value.name}-css.css`)
}

function exportSCSS() {
    const c = result.value.colors
    const out = `$brand-colors: (
  "surface": ${c.surface},
  "surface-alt": ${c.surfaceAlt},
  "accent": ${c.accent},
  "accent-secondary": ${c.accentSecondary},
  "text-primary": ${c.textPrimary},
  "text-secondary": ${c.textSecondary},
  "border": ${c.border}
);`
    downloadText(out, `${result.value.name}.scss`)
}

function exportTailwind() {
    const c = result.value.colors
    const out = `module.exports = {
  theme: {
    extend: {
      colors: {
        surface: "${c.surface}",
        surfaceAlt: "${c.surfaceAlt}",
        accent: "${c.accent}",
        accentSecondary: "${c.accentSecondary}",
        textPrimary: "${c.textPrimary}",
        textSecondary: "${c.textSecondary}",
        border: "${c.border}"
      }
    }
  }
}`
    downloadText(out, `${result.value.name}-tailwind.js`)
}

function exportSVG() {
    if (!result.value?.colors) return
    const entries = Object.entries(result.value.colors)
    const title = result.value.name || 'NexGrid Palette'
    const cols = 7
    const gap = 18
    const pad = 56
    const topBlock = 110
    const cardW = 150
    const cardH = Math.round(cardW * (4 / 3))
    const labelH = 44
    const rows = Math.ceil(entries.length / cols)
    const gridW = cols * cardW + (cols - 1) * gap
    const gridH = rows * (cardH + labelH) + (rows - 1) * gap
    const W = pad * 2 + gridW
    const H = pad * 2 + topBlock + gridH + 18
    const isDark = document.documentElement.classList.contains('dark')

    let svg = `
<svg xmlns="http://www.w3.org/2000/svg" width="${W}" height="${H}">
  <rect width="100%" height="100%" fill="${isDark ? '#09090B' : '#FFFFFF'}" rx="32"/>
  <text x="${pad}" y="${pad + 16}" font-size="10" font-weight="800"
    fill="${isDark ? '#38BDF8' : '#0284C7'}"
    font-family="Inter" letter-spacing="1.2">
    GENERATED WITH AI NEXGRIDCO
  </text>
  <text x="${pad}" y="${pad + 72}" font-size="32" font-weight="800"
    fill="${isDark ? '#FAFAFA' : '#09090B'}"
    font-family="Inter">
    ${escapeXML(title)}
  </text>
`
    const startX = pad
    const startY = pad + topBlock
    entries.forEach(([key, hex], i) => {
        const r = Math.floor(i / cols)
        const c = i % cols
        const x = startX + c * (cardW + gap)
        const y = startY + r * (cardH + labelH + gap)
        svg += `
  <rect x="${x}" y="${y}" width="${cardW}" height="${cardH}" rx="16" fill="${hex}"/>
  <text x="${x + cardW / 2}" y="${y + cardH + 16}" text-anchor="middle"
    font-size="10" font-weight="800" fill="#A1A1AA" font-family="Inter">
    ${escapeXML(formatKey(key).toUpperCase())}
  </text>
  <text x="${x + cardW / 2}" y="${y + cardH + 34}" text-anchor="middle"
    font-size="12" fill="${isDark ? '#E4E4E7' : '#52525B'}"
    font-family="JetBrains Mono">
    ${hex.toUpperCase()}
  </text>
`
    })
    svg += '</svg>'
    downloadText(svg, `${sanitizeFilename(title)}.svg`)
}

function escapeXML(str) {
    return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&apos;')
}

function exportPNG() {
    if (!result.value?.colors) return
    const entries = Object.entries(result.value.colors)
    const title = result.value.name || 'NexGrid Palette'
    const cols = 7
    const gap = 18
    const pad = 56
    const topBlock = 110
    const cardW = 150
    const cardH = Math.round(cardW * (4 / 3))
    const labelH = 44
    const rows = Math.ceil(entries.length / cols)
    const gridW = cols * cardW + (cols - 1) * gap
    const gridH = rows * (cardH + labelH) + (rows - 1) * gap
    const W = pad * 2 + gridW
    const H = pad * 2 + topBlock + gridH + 18
    const dpr = Math.max(2, Math.min(3, Math.floor(window.devicePixelRatio || 2)))
    const canvas = document.createElement('canvas')
    canvas.width = W * dpr
    canvas.height = H * dpr
    const ctx = canvas.getContext('2d')
    ctx.scale(dpr, dpr)
    const isDark = document.documentElement.classList.contains('dark')
    const bgTop = isDark ? '#09090B' : '#FFFFFF'
    const bgBottom = isDark ? '#050507' : '#FAFAFA'
    const bg = ctx.createLinearGradient(0, 0, 0, H)
    bg.addColorStop(0, bgTop)
    bg.addColorStop(1, bgBottom)
    ctx.fillStyle = bg
    ctx.fillRect(0, 0, W, H)
    drawGlow(ctx, W - 210, 180, 280, isDark ? 'rgba(14,165,233,.14)' : 'rgba(14,165,233,.10)')
    drawGlow(ctx, 180, H - 180, 280, isDark ? 'rgba(99,102,241,.12)' : 'rgba(99,102,241,.08)')
    const badgeText = 'Generated with AI NexGridCo'
    ctx.save()
    ctx.font = '800 10px Inter, system-ui, -apple-system, Segoe UI, Roboto, sans-serif'
    const badgePadX = 10
    const badgeW = ctx.measureText(badgeText).width + badgePadX * 2
    const badgeH = 22
    const badgeX = pad
    const badgeY = pad
    roundedRect(ctx, badgeX, badgeY, badgeW, badgeH, 999)
    ctx.fillStyle = isDark ? 'rgba(14,165,233,0.12)' : 'rgba(14,165,233,0.10)'
    ctx.fill()
    ctx.strokeStyle = isDark ? 'rgba(14,165,233,0.22)' : 'rgba(14,165,233,0.20)'
    ctx.stroke()
    ctx.fillStyle = isDark ? '#38BDF8' : '#0284C7'
    ctx.fillText(badgeText.toUpperCase(), badgeX + badgePadX, badgeY + 15)
    ctx.restore()
    ctx.save()
    ctx.fillStyle = isDark ? '#FAFAFA' : '#09090B'
    ctx.font = '800 32px Inter, system-ui, -apple-system, Segoe UI, Roboto, sans-serif'
    ctx.fillText(title, pad, pad + 72)
    ctx.restore()
    const startX = pad
    const startY = pad + topBlock
    entries.forEach(([key, hex], idx) => {
        const r = Math.floor(idx / cols)
        const c = idx % cols
        const x = startX + c * (cardW + gap)
        const y = startY + r * (cardH + labelH + gap)
        drawCardShadow(ctx, x, y, cardW, cardH, 16, isDark)
        ctx.save()
        roundedRect(ctx, x, y, cardW, cardH, 16)
        ctx.clip()
        ctx.fillStyle = hex
        ctx.fillRect(x, y, cardW, cardH)
        ctx.restore()
        ctx.save()
        roundedRect(ctx, x, y, cardW, cardH, 16)
        ctx.strokeStyle = isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.06)'
        ctx.stroke()
        ctx.restore()
        const labelY = y + cardH + 16
        ctx.save()
        ctx.textAlign = 'center'
        ctx.fillStyle = '#A1A1AA'
        ctx.font = '800 10px Inter'
        ctx.fillText(formatKey(key).toUpperCase(), x + cardW / 2, labelY)
        ctx.fillStyle = isDark ? '#E4E4E7' : '#52525B'
        ctx.font = '500 12px "JetBrains Mono"'
        ctx.fillText(hex.toUpperCase(), x + cardW / 2, labelY + 18)
        ctx.restore()
    })
    canvas.toBlob(blob => {
        const url = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = `${sanitizeFilename(title)}.png`
        a.click()
        URL.revokeObjectURL(url)
    })
}

function roundedRect(ctx, x, y, w, h, r) {
    const rr = Math.min(r, w / 2, h / 2)
    ctx.beginPath()
    ctx.moveTo(x + rr, y)
    ctx.arcTo(x + w, y, x + w, y + h, rr)
    ctx.arcTo(x + w, y + h, x, y + h, rr)
    ctx.arcTo(x, y + h, x, y, rr)
    ctx.arcTo(x, y, x + w, y, rr)
    ctx.closePath()
}

function drawGlow(ctx, cx, cy, radius, color) {
    ctx.save()
    const g = ctx.createRadialGradient(cx, cy, 0, cx, cy, radius)
    g.addColorStop(0, color)
    g.addColorStop(1, 'rgba(0,0,0,0)')
    ctx.fillStyle = g
    ctx.beginPath()
    ctx.arc(cx, cy, radius, 0, Math.PI * 2)
    ctx.fill()
    ctx.restore()
}

function drawCardShadow(ctx, x, y, w, h, r, isDark) {
    ctx.save()
    ctx.shadowColor = isDark ? 'rgba(0,0,0,0.55)' : 'rgba(0,0,0,0.12)'
    ctx.shadowBlur = isDark ? 18 : 14
    ctx.shadowOffsetY = isDark ? 10 : 8
    ctx.fillStyle = 'rgba(0,0,0,0)'
    roundedRect(ctx, x, y, w, h, r)
    ctx.fill()
    ctx.restore()
}

function sanitizeFilename(name) {
    return String(name || 'palette')
        .replace(/\/\\?%*:|"<>]/g, '-')
        .replace(/\s+/g, ' ')
        .trim()
        .slice(0, 80)
}

function openDeleteModal(item) {
    itemToDelete.value = item
    showDeleteModal.value = true
}

function closeDeleteModal() {
    showDeleteModal.value = false
    itemToDelete.value = null
}

async function confirmDelete() {
    if (!itemToDelete.value) return
    try {
        await axios.delete(`/color-ai/history/generator/${itemToDelete.value.id}`)
        history.value = history.value.filter(h => h.id !== itemToDelete.value.id)
    } finally {
        closeDeleteModal()
    }
}

onMounted(() => {
    fetchHistory()
})
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap');

.font-sans {
    font-family: 'Inter', sans-serif;
}

.font-mono {
    font-family: 'JetBrains Mono', monospace;
}

.custom-scrollbar::-webkit-scrollbar {
    width: 4px;
}

.custom-scrollbar::-webkit-scrollbar-track {
    background: transparent;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
    background-color: rgba(161, 161, 170, 0.2);
    border-radius: 4px;
}

.custom-scrollbar:hover::-webkit-scrollbar-thumb {
    background-color: rgba(161, 161, 170, 0.4);
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.list-enter-active,
.list-leave-active {
    transition: all 0.4s ease;
}

.list-enter-from,
.list-leave-to {
    opacity: 0;
    transform: translateX(-20px);
}

.modal-enter-active,
.modal-leave-active {
    transition: opacity 0.3s ease;
}

.modal-enter-from,
.modal-leave-to {
    opacity: 0;
}

.modal-enter-active .transform,
.modal-leave-active .transform {
    transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.modal-enter-from .transform,
.modal-leave-to .transform {
    transform: scale(0.95) translateY(10px);
}

@keyframes blob {
    0% {
        transform: translate(0px, 0px) scale(1);
    }

    33% {
        transform: translate(30px, -50px) scale(1.1);
    }

    66% {
        transform: translate(-20px, 20px) scale(0.9);
    }

    100% {
        transform: translate(0px, 0px) scale(1);
    }
}

.animate-blob {
    animation: blob 10s infinite;
}

@keyframes shimmer {
    100% {
        transform: translateX(100%);
    }
}

.animate-shimmer {
    animation: shimmer 2s infinite;
}

@keyframes enter {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.animate-enter {
    animation: enter 0.6s cubic-bezier(0.16, 1, 0.3, 1) backwards;
}

.material-symbols-rounded {
    font-variation-settings: 'FILL' 0, 'wght' 400, 'GRAD' 0, 'opsz' 24;
}
</style>